<template>
  <div class="card">
    <div class="card__wrapper">
      <BaseLink
        v-if="category.articles.length > 1"
        class="typography__headline3 card__link"
        :href="`/${locale}/faq/categories/${category.slug}`"
      >
        <span v-html="category.name"
      /></BaseLink>

      <span
        v-else
        class="typography__headline3"
        v-html="category.name"
      />

      <ul class="card__list">
        <li
          v-for="article in category.articles.slice(0, 3)"
          :key="article.slug"
        >
          <BaseLink
            class="card__link card__article-link"
            :href="`/${locale}/faq/articles/${article.slug}`"
          >
            <span v-html="article.name" />
          </BaseLink>
        </li>
      </ul>
    </div>

    <BaseLink
      v-if="category.articles.length > 3"
      key="base-link-2"
      class="base-button-second base-button-big"
      :href="`/${locale}/faq/categories/${category.slug}`"
    >
       {{ t('entities.FaqCardArticleCategory.allArticles')}}
    </BaseLink>
  </div>
</template>

<script lang="ts" setup>
const { locale, t } = useI18n();

defineProps<{
  category: FaqCategory;
}>();
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  align-items: start;
  row-gap: 24px;
  height: 100%;
  padding: 24px;
  border-radius: 12px;
  background-color: var(--white);
}

.card__wrapper {
  display: flex;
  flex-direction: column;
  align-items: start;
  row-gap: 16px;
}

@media (--hover) {
  .card__link:hover {
    color: var(--grey-2);
  }
}

@media (--hover) {
  .card__link:active {
    color: var(--grey-1-5);
  }
}

.card__list {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

.card__article-link {
  text-decoration: underline;
}
</style>
